import { db } from "./db.js";
import { ref } from "vue";
import { getMember } from "./teams.js";

// ==================== CREATE ====================

function addDocketTask(firmId, data) {
  const ref1 = db.collection(`firms/${firmId}/docketing`).doc();
  data.id = ref1.id;
  return ref1.set(data);
}

function addDocketComment(firmId, docketingId, data) {
  return db
    .collection(`firms/${firmId}/docketing/${docketingId}/comments`)
    .add(data);
}

// ==================== READ ====================

function getDocketTasksByDeadline(firmId) {
  const tasks = ref([]);
  db.collection(`firms/${firmId}/docketing`)
    .orderBy("deadline")
    .onSnapshot((snapshot) => {
      tasks.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    });

  return tasks;
}

async function getDocketTasksByPatentIdByDeadline(firmId, patentId) {
  const tasks = ref([]);
  await db
    .collection(`firms/${firmId}/docketing`)
    .where("patentId", "==", patentId)
    .orderBy("deadline")
    .get()
    .then((querySnaptshot) => {
      tasks.value = querySnaptshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });

  return tasks;
}

async function getDocketTasksByPatentIdByStatus(firmId, patentId) {
  const tasks = ref([]);
  await db
    .collection(`firms/${firmId}/docketing`)
    .where("patentId", "==", patentId)
    .orderBy("status")
    .get()
    .then((querySnaptshot) => {
      tasks.value = querySnaptshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });

  return tasks;
}

function getDocketTasksByStatus(firmId) {
  const tasks = ref([]);
  db.collection(`firms/${firmId}/docketing`)
    .orderBy("status", "asc")
    .onSnapshot((snapshot) => {
      tasks.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    });
  return tasks;
}


//TODO this maybe shouldn't be live like this...
function getDocketComments(firmId, docketingId) {
  const comments = ref([]);
  db.collection(`firms/${firmId}/docketing/${docketingId}/comments`)
    .orderBy("time")
    .onSnapshot((snapshot) => {
      comments.value = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    });
  return comments;
}

async function getDocketTask(firmId, taskId) {
  const task = await db.doc(`firms/${firmId}/docketing/${taskId}`).get();
  return task.exists ? task.data() : null;
}

async function getDocketTasksOfUser(firmId, userId) {
  const tasks = ref([]);
  const member = await getMember(firmId, userId);

  return new Promise((resolve, reject) => {
    const collectionRef = db.collection(`firms/${firmId}/docketing`);
    let query;

    if (member && (member.role == "admin")) {
      query = collectionRef;
    } else {
      query = collectionRef.where("assigned", "array-contains", userId);
    }

    const unsubscribe = query.onSnapshot((querySnapshot) => {
      tasks.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      sortTasksByDeadline(tasks.value);
      resolve({ tasks, unsubscribe }); // Resolve with tasks and unsubscribe function
    }, reject);
  });
}

/*
async function getDocketTasksOfUser(firmId, userId) {
  const tasks = ref([]);
  const member = await getMember(firmId, userId);

  return new Promise((resolve, reject) => {
    const collectionRef = db.collection(`firms/${firmId}/docketing`);

    if (member && member.role == "admin") {
      let query = collectionRef.orderBy("deadline");
      const unsubscribe = query.onSnapshot((querySnapshot) => {
        tasks.value = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        sortTasksByDeadline(tasks.value);
      }, reject);
      resolve({ tasks, unsubscribe });
    } else {
      getPatentsOfUser(firmId, userId).then(({ patents, unsubscribe: unsubscribePatents }) => {
        const unsubscribeTasks = [];

        watch(patents, (newVal) => {
          const patentIds = newVal.map((patent) => patent.id);

          if (!patentIds.length) {
            tasks.value = [];
            unsubscribeTasks.forEach(unsub => unsub());
            unsubscribeTasks.length = 0;
            return;
          }

          // Unsubscribe from the previous docketing tasks listeners if they exist
          unsubscribeTasks.forEach(unsub => unsub());
          unsubscribeTasks.length = 0;

          // Clear the tasks array before adding new tasks
          tasks.value = [];
          console.log("1 tasks value: ", tasks.value);
          // the while loop is to solve the problem that batch array cannot exceed 10
          while (patentIds.length) {
            const batch = patentIds.splice(0, 10);
            const unsubscribe = collectionRef
              .where("patentId", "in", batch)
              .onSnapshot((querySnapshot) => {
                const newTasks = querySnapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
                tasks.value.push(...newTasks);
                sortTasksByDeadline(tasks.value);
              }, reject);
            unsubscribeTasks.push(unsubscribe);
            console.log("2 tasks value: ", tasks.value);
          }
          console.log("3 tasks value: ", tasks.value);
        }, { immediate: true });

        resolve({
          tasks,
          unsubscribe: () => {
            unsubscribePatents();
            unsubscribeTasks.forEach(
              unsub => unsub()
            );
          }
        });
      }).catch(reject);
    }
  });
}
  */

function sortTasksByDeadline(tasks) {
  tasks.sort((a, b) => {
    const keyA = a.deadline;
    const keyB = b.deadline;
    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
}

// ==================== UPDATE ====================

async function updateDocketTask(firmId, taskId, data, transaction = null) {
  const taskRef = db.doc(`firms/${firmId}/docketing/${taskId}`);
  if (transaction) {
    transaction.update(taskRef, data);
  } else {
    await taskRef.update(data);
  }
}

// ==================== NO DELETE ALLOWED ====================

export {
  addDocketTask,
  addDocketComment,
  getDocketTasksByPatentIdByDeadline,
  getDocketTasksByPatentIdByStatus,
  getDocketTask,
  getDocketTasksByDeadline,
  getDocketTasksByStatus,
  getDocketComments,
  getDocketTasksOfUser,
  updateDocketTask,
};
